import "../../../static/js/loaders/jquery";

var overlap = $(".program-list-block-container").attr('data-overlap')
if (overlap == "True") {
  $(".program-list-block-container").css("margin-top", -$(".program-list-block-upper").height())
}

$('#programlist').on('change', function () {
  var url = $(this).val();
  window.location = url;
});



